import ConversationDetails from "./ConversationDetails";

export default ConversationDetails;
